import React ,{useState} from "react";
import { Table, Spinner, Badge } from "reactstrap";
import { toast } from "react-toastify";
import { deleteProjectApi, updateProjectStatusApi, } from "../../apiServices/projectServices";
import ConfirmModal from "../../Modal/Common/ConfirmModal";
import useConfirm from "../../Hooks/useConfirm";
import { useNavigate } from "react-router-dom";

const ProjectTable = ({ projects, loading, fetchProjects, onView, onEdit }) => {
  const navigate = useNavigate();
  const { isOpen, config, loading: confirmLoading, openConfirm, closeConfirm, handleConfirm, } = useConfirm();
  const [hoveredRow, setHoveredRow] = useState(null);
  const handleDelete = (id) => {
    openConfirm({
      title: "Delete Project",
      message: "Are you sure you want to delete this project?",
      confirmText: "Delete",
      onConfirm: async () => {
        const res = await deleteProjectApi(id);

        if (!res.success) {
          throw new Error(res.message);
        }

        toast.success("Project deleted");
        fetchProjects();
      },
    });
  };
  const [popupPos, setPopupPos] = useState({ top: 0, left: 0 });

  const handleMouseEnter = (e, itemId) => {
    const rect = e.currentTarget.getBoundingClientRect();

    setHoveredRow(itemId);
    setPopupPos({
      top: rect.bottom + 5,
      left: rect.left,
    });
  };
  const handleStatusToggle = (id, currentStatus) => {
    openConfirm({
      title: "Update Status",
      message: "Are you sure you want to change project status?",
      confirmText: "Yes",
      onConfirm: async () => {
        const res = await updateProjectStatusApi(id, !currentStatus);

        if (!res.success) {
          throw new Error(res.message);
        }

        toast.success("Status updated");
        fetchProjects();
      },
    });
  };

  return (
    <div className="card shadow-sm">
      <div className="card-body">
        {loading ? (
          <div className="text-center py-5">
            <Spinner />
          </div>
        ) : (
          <div className="table-responsive">
            <Table className="align-middle table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-center">#</th>
                  <th>Project</th>
                  {/* <th>Builder</th> */}
                  {/* <th>Amenities</th> */}
                  <th>Status</th>
                  {/* <th>Location</th> */}
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {projects?.length > 0 ? (
                  projects.map((item, index) => (
                    <tr key={item._id} onMouseEnter={(e) => handleMouseEnter(e, item._id)} onMouseLeave={() => setHoveredRow(null)} >
                      <td className="text-center p-0 position-relative" style={{ minWidth: "55px" }} >
                          {hoveredRow === item._id ? (
                            <button
                              className="btn btn-sm btn-light"
                              onClick={() => navigate(`/project-details/${item.slug}`)}
                            >
                              <i className="mdi mdi-eye"></i>
                            </button>
                          ) : (
                            <span className="fw-semibold text-muted">{index + 1}</span>
                          )}
                        </td>

                    <td className="project-name-cell">
                      <div className="project-name">
                        {item.projectName}
                      </div>

                      <small className="text-muted d-block mt-1">
                        {item.reraNumber}
                      </small>

                      <Badge color="info" className="mt-1">
                        {item.projectType}
                      </Badge>
                    </td>

                      {/* <td>{item?.builderName?.name}</td> */}

                     {/* <td style={{ position: "relative" }}>
                        {item.amenities?.length > 0 ? (
                          <>
                            <div>
                              {item.amenities.slice(0, 2).map((a, i) => (
                                <span key={a._id}>
                                  <span className="badge bg-light text-dark mb-1">
                                    {a.name}
                                  </span>
                                  {i === 0 && <br />}
                                </span>
                              ))}
                            </div>

                            {item.amenities.length > 2 && (
                              <span
                                className="badge bg-secondary mt-1"
                                style={{ cursor: "pointer" }}
                              >
                                +{item.amenities.length - 2}
                              </span>
                            )}

                            {item.amenities.length > 2 && hoveredRow === item._id && (
                              <div style={{position: "fixed",top: popupPos.top, left: popupPos.left, zIndex: 9999,background: "#fff",border: "1px solid #ddd",padding: "8px",borderRadius: "6px",boxShadow: "0 2px 10px rgba(0,0,0,0.1)",minWidth: "150px",}}>
                                {item.amenities.slice(2).map((a) => (
                                  <div key={a._id} className="small text-dark mb-1">
                                    • {a.name}
                                  </div>
                                ))}
                              </div>
                            )}
                          </>
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td> */}
                      <td>
                        <Badge color="secondary">
                          {item.projectStatus}
                        </Badge>
                        <br/>
                        <Badge
                          color={item.isActive ? "success" : "dark"}
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleStatusToggle(item._id, item.isActive)
                          }
                        >
                          {item.isActive ? "Active" : "Inactive"}
                        </Badge>
                      </td>

                      {/* <td>
                        {item?.location?.city || item?.location || "-"}
                      </td> */}


                      <td>
                          <i className="mdi mdi-eye view-mdi" onClick={() => navigate(`/project-details/${item.slug}`)}></i>
                          <i className="mdi mdi-pencil edit-mdi" onClick={() => onEdit(item)}></i>
                          <i className="mdi mdi-delete delete-mdi" onClick={() => handleDelete(item._id)}></i>                      
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-4">
                      No Projects Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </div>
      <ConfirmModal isOpen={isOpen} toggle={closeConfirm} title={config.title} message={config.message} confirmText={config.confirmText} onConfirm={handleConfirm} loading={confirmLoading} />
    </div>
    
  );
};

export default ProjectTable;